import type { MenuListEntry } from "@/components/Menu/Menu";
import { getActiveBackendSource, getBackendSourceLabel, isBackendSourceToggleAvailable } from "./resolve";
import { applyBackendSource, type BackendSource } from "./storage";

export const API_BACKEND_LABEL = "API Backend";

function buildBackendSourceItem(source: BackendSource, active: BackendSource): MenuListEntry {
  const label = getBackendSourceLabel(source);

  return {
    label,
    ariaLabel:
      active === source ? `Selected ${API_BACKEND_LABEL}: ${label}` : `Switch ${API_BACKEND_LABEL} to ${label}`,
    iconName: active === source ? "check" : undefined,
    reserveLeadingIconSpace: true,
    onClick: () => {
      if (active === source) return;

      applyBackendSource(source);
    },
    dataTestId: `backend-source-${source}`
  };
}

export function getBackendSourceMenuItems(): MenuListEntry[] {
  if (!isBackendSourceToggleAvailable()) {
    return [];
  }

  const active = getActiveBackendSource();

  return [
    { type: "headline", label: API_BACKEND_LABEL, useDivider: false },
    buildBackendSourceItem("shared-dev", active),
    buildBackendSourceItem("localhost", active)
  ];
}
